import { BaseModel } from '../BaseModel/BaseModel';
import { RawTemplateCategory, TemplateCategoryEntity } from './Types';
import {
    TemplateCategoryEnum,
    TemplateCategoryType,
} from '../../Shared/Enums/TemplateCategoryEnum';
import { TemplateEntity } from '../Template/Types';
import { PaginationResponse } from '../../Shared/Interfaces/Api/Pagination';

export class TemplateCategoryModel
    extends BaseModel<RawTemplateCategory, TemplateCategoryEntity>
    implements TemplateCategoryEntity
{
    category: TemplateCategoryType | null = null;
    createdAt: string = new Date().toISOString();
    deletedAt: string | null = null;
    description: string = '';
    id: number = 0;
    slug: string | null = null;
    updatedAt: string = new Date().toISOString();
    templateGroups: {
        data: [];
        pagination: PaginationResponse;
    } = {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 0,
            lastPage: 0,
            to: 0,
            from: 0,
        },
    };
    templates: {
        data: TemplateEntity[];
        pagination: PaginationResponse;
    } = {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 0,
            lastPage: 0,
            to: 0,
            from: 0,
        },
    };

    constructor(category?: RawTemplateCategory) {
        super();
        if (category) {
            this.initialize(category);
        }
    }

    initialize(raw: RawTemplateCategory): void {
        this.category = raw.category;
        this.createdAt = raw.created_at;
        this.deletedAt = raw.deleted_at;
        this.description = raw.description;
        this.id = raw.id;
        this.slug = raw.slug;
        this.updatedAt = raw.updated_at;
        this.templateGroups = raw.templateGroups;
        this.templates = raw.templates;
    }

    parse(): RawTemplateCategory {
        return {
            category: this.category,
            created_at: this.createdAt,
            deleted_at: this.deletedAt,
            description: this.description,
            id: this.id,
            slug: this.slug,
            updated_at: this.updatedAt,
            templateGroups: this.templateGroups,
            templates: this.templates,
        };
    }
}
